export const SET_SIGNUP_BANNER = (el, payload) => {
  el.signupBanner = payload;
}
